import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  TablePagination,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { muiTheme } from "../../shared/theme/muiTheme";

const DataTable = ({
  columns,
  rows,
  onEdit,
  onActivate,
  loading,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  maxHeight = "calc(100vh - 150px)",
}) => {
  return (
    <ThemeProvider theme={muiTheme}>
      <TableContainer component={Paper} sx={{ maxHeight, overflow: "auto" }}>
        <Table size="small" stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow
              sx={{
                height: "2.5rem",
                backgroundColor: "primary.main",
              }}
            >
              {columns.map((col) => (
                <TableCell
                  sx={{
                    color: "primary.contrastText",
                    fontWeight: 600,
                    width: col.width,
                    whiteSpace: "nowrap",
                    backgroundColor: "primary.main",
                  }}
                  key={col.field}
                >
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  sx={{ py: 3 }}
                >
                  <Box
                    sx={{ display: "flex", justifyContent: "center", my: 2 }}
                  >
                    <CircularProgress size={24} color="primary" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : rows?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              rows?.map((row, index) => (
                <TableRow key={row._id || index}>
                  {columns.map((col) => (
                    <TableCell
                      key={col.field}
                      align={col.align ?? "left"}
                      sx={{
                        whiteSpace: "nowrap",
                        width: col.width,
                        minWidth: col.width,
                      }}
                    >
                      {col.renderCell
                        ? col.renderCell(row, onEdit, onActivate)
                        : row[col.field]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        // rowsPerPageOptions={[10, 50, 100, { label: "All", value: 1000 }]}
        rowsPerPageOptions={[10, 50, 100]}
        component="div"
        count={totalCount || 0}
        rowsPerPage={rowsPerPage || 50}
        page={page || 0}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </ThemeProvider>
  );
};

export default DataTable;
